import React from 'react';
export default function BlockState({ resource, name, children }) {
  if (resource.loading) return <p role="status">Loading {name}…</p>;
  if (resource.error) return <div role="status"><p>This {name} is unavailable.</p>
    <button onClick={resource.retry}>Retry {name}</button></div>;
  return children;
}
